import script from "./ConsumerInformationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsumerInformationView.vue?vue&type=script&setup=true&lang=ts"

import "./ConsumerInformationView.vue?vue&type=style&index=0&id=e929e6be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e929e6be"]])

export default __exports__